exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remarks[data-v-4d8be40a]{overflow-x:scroll;white-space:pre;width:200px;padding:8px 0;box-sizing:border-box;line-height:.8}", ""]);

// exports
